import script from "./ExportDSAttendances.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportDSAttendances.vue?vue&type=script&setup=true&lang=ts"

import "./ExportDSAttendances.vue?vue&type=style&index=0&id=18e68c2b&lang=css"
import "./ExportDSAttendances.vue?vue&type=style&index=1&id=18e68c2b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e68c2b"]])

export default __exports__